module.exports = __webpack_public_path__ + "img/ch13_12_古镇报人数.e09e14d9.jpg";